import km from 'keymirror'
import _ from 'underscore'

export default _.extend({
  WECHAT_GET_OPEN_NEED_AUTHORITY: 6814008,
}, km({
  WECHAT_GET_OPENID_SUCCESS: null,
  WECHAT_GET_OPENID_ERROR: null,
}))
